import MarqueeHero from 'components/ui/MarqueeHero';

import desktop1 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_01@2x.jpg';
import desktop2 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_02@2x.jpg';
import desktop3 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_03@2x.jpg';
import desktop4 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_04@2x.jpg';
import desktop5 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_05@2x.jpg';
import desktop6 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_06@2x.jpg';
import desktop7 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_07@2x.jpg';
import desktop8 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeDesktop/new_photo_08@2x.jpg';

import tablet1 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_01@2x.jpg';
import tablet2 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_02@2x.jpg';
import tablet3 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_03@2x.jpg';
import tablet4 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_04@2x.jpg';
import tablet5 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_05@2x.jpg';
import tablet6 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_06@2x.jpg';
import tablet7 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_07@2x.jpg';
import tablet8 from '../../../../public/static-preauth/images/AdvisorLp/MarqueTablet/new_photo_08@2x.jpg';

import mobile1 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_1@2x.jpg';
import mobile2 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_2@2x.jpg';
import mobile3 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_3@2x.jpg';
import mobile4 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_4@2x.jpg';
import mobile5 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_5@2x.jpg';
import mobile6 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_6@2x.jpg';
import mobile7 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_7@2x.jpg';
import mobile8 from '../../../../public/static-preauth/images/AdvisorLp/MarqueeMobile/photo_8@2x.jpg';

const desktopImages = [
  { src: desktop1, alt: '', width: 418, height: 257 },
  { src: desktop2, alt: '', width: 268, height: 331 },
  { src: desktop3, alt: '', width: 257, height: 257 },
  { src: desktop4, alt: '', width: 331, height: 331 },
  { src: desktop5, alt: '', width: 268, height: 331 },
  { src: desktop6, alt: '', width: 418, height: 257 },
  { src: desktop7, alt: '', width: 257, height: 331 },
  { src: desktop8, alt: '', width: 331, height: 331 },
];

const tabletImages = [
  { src: tablet1, alt: '', width: 250, height: 154 },
  { src: tablet2, alt: '', width: 161, height: 200 },
  { src: tablet3, alt: '', width: 154, height: 154 },
  { src: tablet4, alt: '', width: 200, height: 200 },
  { src: tablet5, alt: '', width: 160, height: 200 },
  { src: tablet6, alt: '', width: 249, height: 154 },
  { src: tablet7, alt: '', width: 154, height: 200 },
  { src: tablet8, alt: '', width: 200, height: 200 },
];

const mobileImages = [
  { src: mobile1, alt: '', width: 156, height: 96 },
  { src: mobile2, alt: '', width: 100, height: 124 },
  { src: mobile3, alt: '', width: 96, height: 96 },
  { src: mobile4, alt: '', width: 124, height: 124 },
  { src: mobile5, alt: '', width: 99, height: 124 },
  { src: mobile6, alt: '', width: 155, height: 96 },
  { src: mobile7, alt: '', width: 95, height: 124 },
  { src: mobile8, alt: '', width: 122, height: 124 },
];

const AdvisorLpMarqueeHero = (): JSX.Element => {
  return (
    <MarqueeHero images={{ desktop: desktopImages, mobile: mobileImages, tablet: tabletImages }} />
  );
};

export default AdvisorLpMarqueeHero;
